module.exports = __webpack_public_path__ + "images/mobile-background-2.png?v=5c7cda53e967a8f6de3ab16ff4f06eb9";